<template>
    <header class="library-header">
      <div class="mobile-design">
        <library-logo />
        <mobile-menu />
      </div>
      <p class="library-name" v-if="library">
        {{ library.title }}
      </p>
      <search-bar v-if="!removeSearchBar" @openSearchResult="openSearchResult" />
     <header-instruments/>
    </header>
</template>

<script>
import LibraryLogo from '@/components/library-logo'
import SearchBar from '@/components/search-bar'
import { mapActions, mapState } from 'vuex'
import HeaderInstruments from '@/components/header-instruments'
import MobileMenu from '@/components/mobile-menu'

export default {
  name: 'library-header',
  components: { MobileMenu, HeaderInstruments, LibraryLogo, SearchBar },
  props: {
    removeSearchBar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      filtersArray: state => state.collections.filtersArray,
      library: state => state.base.library,
      toggleBaseMenu: state => state.base.closeHeaderMenu
    })
  },
  methods: {
    ...mapActions(['toggleBaseLibraryMenu']),
    openSearchResult () {
      this.$emit('openSearchResult')
    }
  }
}
</script>
